import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "automation-wizard-field-document-type-status" }

import { computed, watch, inject } from 'vue';
import type { Translator } from 'js/shims-vue';
import { allStatus } from 'Dictionaries/statusColors';
import SalesDocumentsStatus from 'Config/authenticated/SalesDocumentsStatus';

interface StatusDefinition {
    label: string;
    shortLabel: string;
}

interface Field {
    id: string;
    type: string;
    required?: boolean;
    disabled?: boolean;
    currentError?: string;
    props?: {
        formItem?: Record<string, unknown>;
        select?: Record<string, unknown>;
    };
}

interface Props {
    field: Field;
    formData?: Record<string, unknown>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AutomationWizardFieldDocumentTypeStatus',
  props: /*@__PURE__*/_mergeModels({
    field: {},
    formData: { default: () => ({}) }
  }, {
    "modelValue": { default: '' },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const $t = inject('$t') as Translator;

const STATUS_COLORS: Record<string, { color: string; icon?: string }> = allStatus;

const salesDocumentsStatus = SalesDocumentsStatus as Record<
    string,
    Record<string, StatusDefinition>
>;

const EXCLUDED_STATUSES: ReadonlySet<string> = new Set(['draft']);

const props = __props;

const modelValue = _useModel<string | number>(__props, "modelValue");

const DOCUMENT_TYPES: { value: string; labelKey: string }[] = [
    { value: 'invoice', labelKey: 'common.labels.invoice' },
    { value: 'estimate', labelKey: 'common.labels.estimate' },
    { value: 'order', labelKey: 'common.labels.order' },
    { value: 'delivery', labelKey: 'common.labels.delivery' },
];

const isStatusField = computed<boolean>(() => {
    return props.field.id?.includes('documentStatus') || false;
});

const selectedDocumentType = computed<string | null>(() => {
    if (!isStatusField.value) {
        return null;
    }
    return (props.formData.documentType as string) || null;
});

const disabled = computed<boolean>(() => {
    return props.field.disabled || (isStatusField.value && !selectedDocumentType.value);
});

const options = computed<
    { value: string; label: string; color?: string; icon?: string }[]
>(() => {
    if (isStatusField.value) {
        const docType = selectedDocumentType.value;
        if (!docType || !salesDocumentsStatus[docType]) {
            return [];
        }
        return Object.entries(salesDocumentsStatus[docType])
            .filter(([value]) => !EXCLUDED_STATUSES.has(value))
            .map(([value, { shortLabel }]) => ({
                value,
                label: shortLabel,
                color: STATUS_COLORS[value]?.color,
                icon: STATUS_COLORS[value]?.icon,
            }));
    }
    return DOCUMENT_TYPES.map((docType) => ({
        value: docType.value,
        label: $t.__(docType.labelKey),
    }));
});

const formItemProps = computed<Record<string, unknown>>(() => {
    return {
        ...props.field.props?.formItem,
        label: props.field.props?.formItem?.label || '',
        required: props.field.required || false,
        requiredLabel:
            (props.field.props?.formItem?.requiredLabel as string) ||
            $t.__('common.labels.required'),
    };
});

const selectProps = computed<Record<string, unknown>>(() => {
    return {
        ...props.field.props?.select,
    };
});

watch(selectedDocumentType, (newDocType, oldDocType) => {
    if (isStatusField.value && oldDocType && oldDocType !== newDocType && modelValue.value) {
        modelValue.value = '';
    }
});

return (_ctx: any,_cache: any) => {
  const _component_CompassTag = _resolveComponent("CompassTag")!
  const _component_CompassDropdownOption = _resolveComponent("CompassDropdownOption")!
  const _component_CompassSelect = _resolveComponent("CompassSelect")!
  const _component_CompassFormItem = _resolveComponent("CompassFormItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CompassFormItem, _mergeProps(formItemProps.value, {
      error: __props.field.currentError || ''
    }), {
      default: _withCtx(() => [
        _createVNode(_component_CompassSelect, _mergeProps(selectProps.value, {
          modelValue: modelValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          disabled: disabled.value,
          type: isStatusField.value ? _ctx.CompassEnums.SelectType.TAG : _ctx.CompassEnums.SelectType.TEXT,
          menuClass: "automation-wizard-document-type-status-select"
        }), {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
              return (_openBlock(), _createBlock(_component_CompassDropdownOption, {
                key: option.value,
                label: option.label,
                value: option.value,
                color: option.color,
                tagIcon: option.icon
              }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                (isStatusField.value)
                  ? {
                      name: "default",
                      fn: _withCtx(() => [
                        _createVNode(_component_CompassTag, {
                          color: option.color,
                          icon: option.icon,
                          size: _ctx.CompassEnums.TagSize.SMALL
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option.label), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color", "icon", "size"])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value", "color", "tagIcon"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */, ["modelValue", "disabled", "type"])
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["error"])
  ]))
}
}

})